<template>
  <div class="attr-select">
    <FormItem
      v-for="(item, index) in form"
      :key="index"
      :label="item.attr"
      :required="item.is_required == 1"
    >
      <Select
        v-model="item.attr_val_id"
        @on-change="onSelectChange"
        clearable
        :multiple="item.type == 2"
        :style="{width: width + 'px'}"
      >
        <Option v-for="citem in item.value" :value="citem.id" :key="citem.id">{{citem.name}}</Option>
      </Select>
    </FormItem>
  </div>
</template>

<script>
export default {
  name: "attr-select",
  props: {
    formUrl: {
      //表单地址
      type: String,
      default: "",
      required: true
    },
    attr: {
      //初始属性
      required: true
    },
    width: {
      default: ""
    }
  },
  data() {
    return {
      form: [],
      event: {
        onChange: "onChange"
      }
    };
  },
  created() {
    this.$http.get(this.formUrl).then(data => {
      this.form = data;
      this.initAttr();
    });
  },
  watch: {
    attr() {
      this.initAttr();
    }
  },
  methods: {
    // on-event
    onSelectChange() {
      const retAry = [];
      this.form.forEach(i => {
        if (!i.attr_val_id) return;
        if (typeof i.attr_val_id == "object") {
          i.attr_val_id.forEach(ci => {
            retAry.push({
              attr_id: i.id,
              attr_val_id: ci
            });
          });
        } else {
          retAry.push({
            attr_id: i.id,
            attr_val_id: i.attr_val_id
          });
        }
      });
      this.$emit(this.event.onChange, JSON.stringify(retAry));
    },
    // other
    initAttr() {
      // init form item
      this.form.forEach(i => {
        for (const item of this.attr) {
          if (item.attr_id == i.id) {
            if (!i.attr_val_id) {
              this.$set(i, "attr_val_id", item.attr_val_id);
            } else {
              if (typeof i.attr_val_id != "object") {
                i.attr_val_id = [i.attr_val_id, item.attr_val_id];
              } else {
                i.attr_val_id.push(item.attr_val_id);
              }
            }
          }
        }
      });
      // init current attr
      this.onSelectChange();
    }
  }
};
</script>